import { render, staticRenderFns } from "./miniprogramforms.vue?vue&type=template&id=220f538d&scoped=true"
import script from "./miniprogramforms.vue?vue&type=script&lang=js"
export * from "./miniprogramforms.vue?vue&type=script&lang=js"
import style0 from "./miniprogramforms.vue?vue&type=style&index=0&id=220f538d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220f538d",
  null
  
)

export default component.exports